import { styled } from "@mui/system";

export const FooterContainer = styled('div')(({ theme }) => ({
    background: `${theme.palette.other.background.footer}`,
    width: '100%',
    height: 'auto',

    [theme.breakpoints.down("md")]: {
        flexDirection: 'column',
    },
}))

export const InnerBox = styled('div')(({ theme }) => ({
    width: "90%",
    display: "flex",
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '24px 29px',
    margin: '0 auto',

    [theme.breakpoints.down("lg")]: {
        width: "95%",
    },

    [theme.breakpoints.down("md")]: {
        flexDirection: 'column',
    }
}))